import Rete from 'rete';
import trackNodeHistory from '../utils/history/trackNodeHistory';

import Comment from './Comment';

class CommentComponent extends Rete.Component {
  constructor(emitter) {
    super('Comment');
    this.render = 'vue';
    this.data.component = Comment;
    this.data.props = {};
    this.emitter = emitter;
  }
  builder = (node) => {
    trackNodeHistory(this, node, this.emitter)
  };
}

export default CommentComponent;
